export default __webpack_public_path__ + "static/m-signbox2-a8da17145251bc6eb8f4f020f2bb577b.jpg";